import { LOCALE } from '@/helpers/locale'
import { forceReload } from '@/helpers'
import { setLanguageCookie } from '@/helpers/languageCookie'
import { resolveInitialLocale } from '@/helpers/resolveLocale'
import i18n from '@/i18n'

const applyLocale = (commit, locale) => {
  if (commit) commit('SET_LOCALE', locale)
  i18n.locale = locale
  document.documentElement.setAttribute('lang', LOCALE[locale].iso)
}

// Set i18n + document lang immediately (before persist plugin can interfere)
const resolvedLocale = resolveInitialLocale()
applyLocale(null, resolvedLocale)

const state = {
  locale: resolvedLocale
}

const mutations = {
  SET_LOCALE (state, data) {
    state.locale = data
  }
}

const actions = {
  initLocaleFromCookie ({ commit, state }) {
    const resolvedLocale = resolveInitialLocale()

    if (state.locale !== resolvedLocale) {
      applyLocale(commit, resolvedLocale)
    }
  },
  setLocale ({ commit }, data) {
    applyLocale(commit, data)

    setLanguageCookie(data)

    forceReload()
  }
}

const getters = {
  getLocaleCode: (state) => LOCALE[state.locale].code,
  getLocaleIso: (state) => LOCALE[state.locale].iso,
  getLocaleServiceLanguageCode: (state) => LOCALE[state.locale].serviceLanguageCode,
  getLocalizedAlgoliaIndexName: (state) => (indexName) => {
    const suffix = LOCALE[state.locale].algoliaSuffix
    return suffix ? `${indexName}_${suffix}` : indexName
  }
}

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
}
